export function backlogStorageValidate(backlog_storage) {
    var result = true; 
    var errors = [];

    result = validateStorage(backlog_storage.storage, errors);
    if(!result) return errors;

    result = validatePendingOperations(backlog_storage.pending_operations, errors);
    if(!result) return errors;

    result = validatePendingStorage(backlog_storage.pending_storage, errors);
    if(!result) return errors;
    
    else return result;
}

function validateStorage(storage, errors) {
    if (Array.isArray(storage)  
     && storage.every(item =>
        typeof item === 'object' &&
        item !== null &&

        typeof item.id === 'number' &&
        !isNaN(item.id) &&

        typeof item.appointment_id === 'number' &&
        !isNaN(item.appointment_id) &&
        
        typeof item.client_name === "string" &&
        item.client_name !== '' &&

        typeof item.date === "string" &&
        item.date !== '' &&

        typeof item.description === "string" &&
        item.description !== '' &&

        typeof item.container_number === "string" &&
        item.container_number !== '' &&

        typeof item.users_name === "string" &&
        item.users_name !== '' &&

        typeof item.pending_operation === "string" &&
        item.pending_operation !== ''

    )) return true;
    else {
        errors.push("backlog_storage_storage_not_valid")
        return false;
    }   
}

function validatePendingOperations(pending_operations, errors) {
    if(typeof pending_operations === 'object' && pending_operations != null){
        if(typeof pending_operations.total === 'number' && !isNaN(pending_operations.total))
            return true;
    }

    errors.push("backlog_storage_pending_operations_not_valid");
    return false;
}

function validatePendingStorage(pending_storage, errors) {
    if(typeof pending_storage === 'object' && pending_storage != null){
        if(typeof pending_storage.total === 'number' && !isNaN(pending_storage.total))
            return true;
    }

    errors.push("backlog_storage_pending_storage_not_valid");
    return false;
}